<template>
    <div class="my-3 md:my-5 overflow-hidden rounded shadow" v-if="showPremium">
        <GoPremium :variant="variant" v-if="showPremium"/>
    </div>
</template>

<script>
    import api from '@/services/api'
    import GoPremium from './PromoCards/GoPremium'

    export default {
        components: {
            GoPremium,
        },
        
        props: {
            variant: { type: Number, required: true },
        },

        computed: {
            showPremium() {
              let clientData = api.clientData();
              
              return !!clientData.verified_at && clientData.user_is_free;
            },
        },
    }
</script>
